import { useState } from "react";
import { db, auth } from "../../services/firebaseConfig";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import {
  uploadMultipleToCloudinary,
} from "../../services/CloudinaryUpload";

export default function AddManpower() {
  const [type, setType] = useState("Individual");
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    state: "",
    contactNumber: "",

    // Individual
    name: "",
    address: "",
    skill: "",
    customSkill: "",
    experience: "",
    expertise: "",
    qualification: "",
    expectedWage: "",

    // Agency
    agencyName: "",
    natureOfWork: "",
    dailyWage: "",
    contractPeriod: "",
    workLocation: "",
    skillRequired: "",
    customSkillRequired: "",
    minimumQualification: "",
    otherInfo: "",
  });

  const [languages, setLanguages] = useState([]);
  const [otherLanguage, setOtherLanguage] = useState("");
  const [images, setImages] = useState([]);
  const [previewImages, setPreviewImages] = useState([]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleLanguageChange = (lang) => {
    if (languages.includes(lang)) {
      setLanguages(languages.filter((l) => l !== lang));
    } else {
      setLanguages([...languages, lang]);
    }
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setImages(files);
    setPreviewImages(files.map((file) => URL.createObjectURL(file)));
  };

  const removeImage = (index) => {
    const newImages = [...images];
    const newPreviews = [...previewImages];
    newImages.splice(index, 1);
    newPreviews.splice(index, 1);
    setImages(newImages);
    setPreviewImages(newPreviews);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!auth.currentUser) {
      alert("Login required");
      return;
    }

    if (languages.length === 0 && !otherLanguage.trim()) {
      alert("Language is mandatory");
      return;
    }

    setLoading(true);

    try {
      let uploadedImages = [];
      if (images.length > 0) {
        const uploaded = await uploadMultipleToCloudinary(images);
        uploadedImages = uploaded.map((img) => img.secure_url);
      }

      const finalLanguages = [
        ...languages,
        otherLanguage.trim(),
      ].filter(Boolean);

      let dataToSave = {
        state: form.state,
        contactNumber: form.contactNumber,
        languages: finalLanguages,
        images: uploadedImages,
        type,
        createdBy: auth.currentUser.uid,
        createdAt: serverTimestamp(),
        rating: 0,
        totalRatings: 0,
      };

      // ===============================
      // INDIVIDUAL
      // ===============================
      if (type === "Individual") {
        dataToSave = {
          ...dataToSave,
          name: form.name,
          address: form.address,
          skill:
            form.skill === "Other"
              ? form.customSkill
              : form.skill,
          experience: form.experience,
          expertise: form.expertise,
          qualification: form.qualification,
          expectedWage: form.expectedWage,
        };
      }

      // ===============================
      // AGENCY
      // ===============================
      if (type === "Agency") {
        dataToSave = {
          ...dataToSave,
          agencyName: form.agencyName,
          natureOfWork: form.natureOfWork,
          dailyWage: form.dailyWage,
          address: form.address,
          contractPeriod: form.contractPeriod,
          workLocation: form.workLocation,
          skillRequired:
            form.skillRequired === "Other"
              ? form.customSkillRequired
              : form.skillRequired,
          minimumQualification: form.minimumQualification,
          otherInfo: form.otherInfo,
        };
      }

      await addDoc(collection(db, "manpower"), dataToSave);

      alert("✅ Manpower Added Successfully");

      window.location.reload();

    } catch (err) {
      alert("Error: " + err.message);
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-600 to-purple-600 flex justify-center items-center p-6">
      <form
        onSubmit={handleSubmit}
        className="bg-white/20 backdrop-blur-md p-6 rounded-2xl w-full max-w-2xl text-white"
      >
        <h2 className="text-3xl font-bold mb-4 text-center">
          Add Manpower
        </h2>

        {/* TYPE */}
        <select
          value={type}
          onChange={(e) => setType(e.target.value)}
          className="w-full mb-3 px-4 py-2 rounded text-black"
        >
          <option>Individual</option>
          <option>Agency</option>
        </select>

        <input
          name="state"
          placeholder="State"
          onChange={handleChange}
          className="w-full mb-3 px-4 py-2 rounded text-black"
        />

        <input
          name="contactNumber"
          placeholder="Contact Number"
          onChange={handleChange}
          className="w-full mb-3 px-4 py-2 rounded text-black"
        />

        {/* ========================= */}
        {/* INDIVIDUAL SECTION */}
        {/* ========================= */}
        {type === "Individual" && (
          <>
            <input name="name" placeholder="Full Name"
              onChange={handleChange}
              className="w-full mb-3 px-4 py-2 rounded text-black" />

            <input name="address" placeholder="Address"
              onChange={handleChange}
              className="w-full mb-3 px-4 py-2 rounded text-black" />

            <select name="skill"
              onChange={handleChange}
              className="w-full mb-3 px-4 py-2 rounded text-black">
              <option value="">Select Skill</option>
              <option>Jharudar</option>
              <option>Latrine Cleaner</option>
              <option>Cook</option>
              <option>Driver</option>
              <option>Gardener</option>
              <option value="Other">Other</option>
            </select>

            {form.skill === "Other" && (
              <input name="customSkill"
                placeholder="Enter Skill"
                onChange={handleChange}
                className="w-full mb-3 px-4 py-2 rounded text-black" />
            )}

            <input name="experience"
              placeholder="Experience (Years)"
              onChange={handleChange}
              className="w-full mb-3 px-4 py-2 rounded text-black" />

            <input name="expertise"
              placeholder="Expertise"
              onChange={handleChange}
              className="w-full mb-3 px-4 py-2 rounded text-black" />

            <input name="qualification"
              placeholder="Qualification"
              onChange={handleChange}
              className="w-full mb-3 px-4 py-2 rounded text-black" />

            <input name="expectedWage"
              placeholder="Expected Wage"
              onChange={handleChange}
              className="w-full mb-3 px-4 py-2 rounded text-black" />
          </>
        )}

        {/* ========================= */}
        {/* AGENCY SECTION */}
        {/* ========================= */}
        {type === "Agency" && (
          <>
            <input name="agencyName"
              placeholder="Agency Name"
              onChange={handleChange}
              className="w-full mb-3 px-4 py-2 rounded text-black" />

            <input name="natureOfWork"
              placeholder="Nature of Work"
              onChange={handleChange}
              className="w-full mb-3 px-4 py-2 rounded text-black" />

            <input name="dailyWage"
              placeholder="Daily Wage"
              onChange={handleChange}
              className="w-full mb-3 px-4 py-2 rounded text-black" />

            <input name="address"
              placeholder="Address"
              onChange={handleChange}
              className="w-full mb-3 px-4 py-2 rounded text-black" />

            <input name="contractPeriod"
              placeholder="Contract Period"
              onChange={handleChange}
              className="w-full mb-3 px-4 py-2 rounded text-black" />

            <input name="workLocation"
              placeholder="Location of Work"
              onChange={handleChange}
              className="w-full mb-3 px-4 py-2 rounded text-black" />

            <select name="skillRequired"
              onChange={handleChange}
              className="w-full mb-3 px-4 py-2 rounded text-black">
              <option value="">Skill Required</option>
              <option>Jharudar</option>
              <option>Latrine Cleaner</option>
              <option>Cook</option>
              <option>Driver</option>
              <option>Gardener</option>
              <option value="Other">Other</option>
            </select>

            {form.skillRequired === "Other" && (
              <input name="customSkillRequired"
                placeholder="Enter Required Skill"
                onChange={handleChange}
                className="w-full mb-3 px-4 py-2 rounded text-black" />
            )}

            <input name="minimumQualification"
              placeholder="Minimum Qualification (Optional)"
              onChange={handleChange}
              className="w-full mb-3 px-4 py-2 rounded text-black" />

            <textarea name="otherInfo"
              placeholder="Any Other Information"
              onChange={handleChange}
              className="w-full mb-3 px-4 py-2 rounded text-black" />
          </>
        )}

        {/* Languages */}
        <div className="mb-3">
          <label>Languages *</label>
          <div className="flex gap-4 mt-2">
            {["English", "Bengali", "Hindi"].map((lang) => (
              <label key={lang}>
                <input
                  type="checkbox"
                  onChange={() => handleLanguageChange(lang)}
                />{" "}
                {lang}
              </label>
            ))}
          </div>

          <input
            placeholder="Other Language"
            onChange={(e) => setOtherLanguage(e.target.value)}
            className="w-full mt-2 px-4 py-2 rounded text-black"
          />
        </div>

        {/* Image */}
        <input
          type="file"
          multiple
          onChange={handleImageChange}
          className="mb-3"
        />

        <div className="grid grid-cols-3 gap-3 mb-3">
          {previewImages.map((img, index) => (
            <div key={index} className="relative">
              <img
                src={img}
                alt="preview"
                className="w-full h-28 object-cover rounded-lg"
              />
              <button
                type="button"
                onClick={() => removeImage(index)}
                className="absolute top-1 right-1 bg-red-600 text-white px-2 py-1 text-xs rounded-full"
              >
                ✕
              </button>
            </div>
          ))}
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full py-3 bg-blue-600 rounded-xl"
        >
          {loading ? "Uploading..." : "Upload"}
        </button>
      </form>
    </div>
  );
}


